<template>
  <div>
    <form @submit.prevent="onSubmit">
        <div class="row">
        <div class="col-12 col-sm-12">
          <label
                for="org_name"
                class="col-12">Organization name : <span class="required">*</span></label>
          <input
                type="org_name"
                name="organization name"
                id="org_name"
                class="col-12 col-sm-12 input-height-35"
                ref="org_name"
                v-validate="'required'"
                v-model="orgName"
                data-vv-as="Organization name"
                maxlength="255"
                >
          <div v-show="verrors.has('organization name')" class="validate-warning-msg">{{ verrors.first('organization name') }}</div>
        </div>
      </div>
      <div class="row margin-bottom-15">
        <div class="col-12 col-sm-12">
        <div class="chkbox-wrapper">
          <input
                type="checkbox"
                name="is_school"
                id="is_school"
                ref="is_school"
                v-model="isSchool"
                :value="1"
                v-on:change="updateRolesEmpty">
          <label for="school_flag">School?</label>
        </div>
      </div>
      </div>
      <div class="row margin-bottom-15">
        <div class="col-12 col-sm-12">
          <label
                for="first_name"
                class="col-12">First name : <span class="required">*</span></label>
          <input
                type="first_name"
                name="first_name"
                id="first_name"
                class="col-12 col-sm-12 input-height-35"
                ref="first_name"
                v-validate="'required'"
                v-model="firstName"
                data-vv-as="First name"
                maxlength="180">
          <div v-show="verrors.has('first_name')" class="validate-warning-msg">{{ verrors.first('first_name') }}</div>
        </div>
      </div>
      <div class="row margin-bottom-15">
        <div class="col-12 col-sm-12">
          <label
              for="last_name"
              class="col-12">Last name : <span class="required">*</span></label>
          <input
              type="last_name"
              name="last_name"
              id="last_name"
              class="col-12 col-sm-12 input-height-35"
              ref="last_name"
              v-validate="'required'"
              v-model="lastName"
              data-vv-as="Last name"
              maxlength="180">
          <div v-show="verrors.has('last_name')" class="validate-warning-msg">{{ verrors.first('last_name') }}</div>
        </div>
      </div>
      <div class="row margin-bottom-15">
        <div class="col-12 col-sm-12">
          <label
              for="phone_number"
              class="col-12">Phone number : </label>
          <input
              type="phone_number"
              name="phone number"
              id="phone_number"
              class="col-12 col-sm-12 input-height-35"
              ref="phone_number"
              v-validate="'numeric'"
              v-model="phoneNumber"
              data-vv-as="Phone number"
              maxlength="20">
          <div v-show="verrors.has('phone number')" class="validate-warning-msg">{{ verrors.first('phone number') }}</div>
        </div>
      </div>
      <div class="row margin-bottom-15" v-if="action == 'insert'">
        <div class="col-12 col-sm-12">
          <label
              for="email"
              class="col-12">Email address : <span class="required">*</span></label>
          <input
              type="email_addr"
              name="email"
              id="email_addr"
              class="col-12 col-sm-12 input-height-35"
              ref="email_addr"
              v-validate="'required|email'"
              v-model="emailAddr"
              data-vv-as="Email address"
              maxlength="180">
          <div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
        </div>
      </div>
      <div class="row margin-bottom-15">
        <div class="col-12 col-sm-12">
          <label
              for="password"
              class="col-12">Roles : <span class="required">*</span></label>

           <div id="company_roles" style="display:block;">
              <div class="chkbox-wrapper">
              <input :value="'ROLE_ADMIN'" type="checkbox" name="roles" id="option1" v-model="userRoles" v-validate data-vv-rules="required" data-vv-as="Roles" v-on:change="autoSelectRole($event)">
              <label>Admin</label>
              </div>
              <div class="chkbox-wrapper">
              <input :value="'ROLE_MENTOR'" type="checkbox" name="roles" id="option2" v-model="userRoles" v-on:change="autoSelectRole($event)">
              <label>Mentor</label>
              </div>
           </div>

           <div id="school_roles" style="display:none;">
              <div class="chkbox-wrapper">
              <input :value="'ROLE_ADMIN'" type="checkbox" name="roles" id="option3" v-model="userRoles" v-validate data-vv-rules="required" data-vv-as="Roles" v-on:change="autoSelectRole($event)">
              <label>Admin</label>
              </div>
              <div class="chkbox-wrapper">
              <input :value="'ROLE_INSTRUCTOR'" type="checkbox" name="roles" id="option4" v-model="userRoles"  v-on:change="autoSelectRole($event)">
              <label>Instructor</label>
              </div>
           </div>

          <div v-show="verrors.has('roles')" class="validate-warning-msg">{{ verrors.first('roles') }}</div>
        </div>
      </div>
      <div class="submit margin-bottom-15">
        <button type="submit" class="btn btn-info btn-md">{{ submit }}</button>
      </div>
    </form>
  </div>
</template>

<script>
  import Vue from 'vue/dist/vue.esm';
  import VeeValidate from 'vee-validate';
  import axios from 'axios';
  import router from '../../router/index.js';

  Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

  export default {
    name: 'managerform',
    props: ['org_name','first_name', 'last_name', 'phone_number', 'email_addr', 'password', 'pw_confirm', 'roles', 'is_school', 'submit', 'action'],
    data() {
      return {
        orgName: this.org_name,
        firstName: this.first_name,
        lastName: this.last_name,
        phoneNumber: this.phone_number,
        emailAddr: this.email_addr,
        userRoles: this.roles,
        isSchool: this.is_school
      }
    },
    methods: {
      onSubmit () {
          this.$validator.validateAll().then((result) => {
          const fieldErrors =  [{}];
          var errorMsg = '';
          if(document.getElementById('is_school').checked == false) {
            if(this.userRoles.indexOf('ROLE_ADMIN') === -1) {
              errorMsg = 'You have to select Admin role';
            }
          }
          else {
            if(this.userRoles.indexOf('ROLE_ADMIN') === -1) {
              errorMsg = 'You have to select Admin role';
            }
          }
          if(errorMsg !== "") {
            var newFieldErr = {field:'roles', msg:errorMsg};
            fieldErrors.push(newFieldErr);
            this.$validator.errors.add(fieldErrors);
            return;
          }
            if(!result) {
              return;
            }
            this.createAccount();
          })
          .catch(() => {
          });
      },
      createAccount() {
          //make axios call to the API
          axios('/accounts',
            {
              method: 'POST',
              data: {
                     "username": this.emailAddr,
                     "email": this.emailAddr,
                     "roles": this.userRoles,
                     "account": {
                         "company_name": this.orgName,
                         "master_admin": false,
                         "school_flag": this.isSchool ? this.is_school: 0,
                     },
                     "first_name": this.firstName,
                     "last_name": this.lastName,
                     "phone_number": this.phoneNumber,
                     "enabled": false,
                     "signin_count": 0
                     }
            },
          )
          .then(response => {
              this.flash({ message: response.data.successMsg, variant: 'success' });
              this.navigate('/listusers');
           })
          .catch(error => {
              const fieldErrors =  [{}];
              var errMsgObj = error.response.data.message;

              Object.keys(errMsgObj).map(key => {
                 var newFieldErr = {field:key, msg:errMsgObj[key]};
                 fieldErrors.push(newFieldErr);
              });
              this.$validator.errors.add(fieldErrors);
           });
      },
      autoSelectRole(e) {
        if(e.target.value == 'ROLE_INSTRUCTOR' && e.target.checked
           && !(document.getElementById('option3').checked)) {
          this.userRoles.push('ROLE_ADMIN');
        }
        if(e.target.value == 'ROLE_MENTOR' && e.target.checked
           && !(document.getElementById('option1').checked)) {
          this.userRoles.push('ROLE_ADMIN');
        }
      },
      updateRolesEmpty() {
        this.userRoles = ['ROLE_PRIMARY_ADMIN'];

        if(this.isSchool) {
           document.getElementById("company_roles").style.display = 'none';
           document.getElementById("school_roles").style.display = 'block';
           this.userRoles.push('ROLE_ADMIN');
        }
        else {
           document.getElementById("school_roles").style.display = 'none';
           document.getElementById("company_roles").style.display = 'block';
           this.userRoles.push('ROLE_ADMIN');
        }
      },
      navigate(path) {
        router.push(path);
    	},

    },
    watch: {
      rolesSelected: function () {
          this.autoSelectRole()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/managerform.vue